import { ReactNode } from "react";

import styles from './panel.module.scss';

export interface PanelProps {
	children?: ReactNode;
}
export const Panel = (props: PanelProps) => {
	return (
		<div className={styles.container}>
			{props.children}
		</div>
	)
}